export const GetFrontendFeatureFlags = () => {
  return `query GetFrontendFeatureFlags {
    getFeatureFlags {
        ... on ErrorListOutput {
            errors {
                id
                message
                type
            }
        }
        ... on AppConfigFlagsOutput {
            ren1520_compliancewelcome_newdesign {
                enabled
            }
            ren1487_coverage_details_newdesign {
                enabled
            }
            crossSellPaymentPage {
                enabled
            }
            ren1402_start_application_new_flow {
                enabled
            }
            ren1924_utm_params_feature_flag {
                enabled
            }
        }
    }
  }`;
};

export interface GetFrontendFeatureFlagsResponse {
  getFeatureFlags: {
    ren1520_compliancewelcome_newdesign: {
      enabled?: boolean;
    };
    ren1487_coverage_details_newdesign: {
      enabled?: boolean;
    };
    crossSellPaymentPage: {
      enabled?: boolean;
    };
    ren1402_start_application_new_flow: {
      enabled?: boolean;
    };
    ren1924_utm_params_feature_flag: {
      enabled?: boolean;
    };
    errors?: {
      id: string;
      message: string;
      type: string;
    }[];
  };
}
